/**
 * @purpose: mengelola popup list generik termasuk lookup hub, agen, customer, pencarian bagging, dan referensi operasional lain.
 * @called_by: modalFactory.open('lg', 'modal.list.html', 'modalListCtrl', ...).
 * @deps: $rootScope, urlServices, toaster, $uibModalInstance, _VAR_GLOBAL, params, $timeout.
 * @public: controller modalListCtrl.
 * @side_effects: memuat data grid popup, melakukan pencarian server-side segera saat user mencari, dan broadcast hasil pilihan ke controller pemanggil.
 */
app.controller('modalListCtrl', function ($rootScope, $scope, urlServices, toaster, $uibModalInstance, _VAR_GLOBAL, params, $timeout) {
        //console.log('paramtere', params)
        $scope.optionsParams = {};
        $scope.params = params;
    var filterSearchTimer = null;

        function normalizePopupText(value) {
            return String(value || '').trim();
        }

        function getPopupSearchDelay() {
            if ($scope.params && $scope.params.functionName === 'pr-poList') {
                return 0;
            }

            return 250;
        }

        function getCustomerNameColumnWidth(rows) {
            var maxLength = 0;

            angular.forEach(rows || [], function (item) {
                var currentLength = normalizePopupText(item && item.CustomerName).length;

                if (currentLength > maxLength) {
                    maxLength = currentLength;
                }
            });

            maxLength = Math.max(maxLength, 28);

            return Math.max(360, Math.min(maxLength * 9, 720));
        }

        function applyCustomerListColumnSizing(rows) {
            var customerNameWidth;

            if ($scope.params.functionName !== 'customerList' || !$scope.optionsParams || !$scope.optionsParams.column) {
                return;
            }

            customerNameWidth = getCustomerNameColumnWidth(rows);

            angular.forEach($scope.optionsParams.column, function (column) {
                if (column.field === 'CustomerName') {
                    column.width = customerNameWidth;
                    column.minWidth = 360;
                }
            });

            if ($scope.gridOptions) {
                $scope.gridOptions.columnDefs = angular.copy($scope.optionsParams.column);
            }
        }

        switch ($scope.params.functionName) {
            case 'itemList':
                $scope.optionsParams = {
                    url: 'api/item?',
                    name: 'Daftar Barang',
                    qry: {

                    },
                    column: [{
                            width: "10%",
                            cellClass: "nggrid-action",
                            name: 'Actions',
                            cellTemplate: ` <div class="btn-group">
                                        <button type="button" class="btn btn-sm btn-icon btn-info" ng-click="grid.appScope.itemSelect(row.entity)"><i class="fa fa-archive"></i></button>


                                      </div>              `
                        },
                        {
                            field: 'KodeBarang',
                            name: 'Kode Barang',
                            width: "*"
                        },
                        {
                            field: 'NamaBarang',
                            name: 'Nama Barang',
                            width: "*"
                        },
                        {
                            field: 'Satuan',
                            name: 'Satuan',
                            width: "*"
                        },
                        {
                            field: 'HargaBeli',
                            name: 'Harga',
                            width: "*"
                        }
                    ]

                }
                break;
            case 'itemListPO':
                $scope.optionsParams = {
                    url: 'api/preceive/' + $scope.params.params.noPo + '/item?',
                    name: 'Daftar Barang',
                    qry: {

                    },
                    column: [{
                            width: "10%",
                            cellClass: "nggrid-action",
                            name: 'Actions',
                            cellTemplate: ` <div class="btn-group">
                                        <button type="button" class="btn btn-sm btn-icon btn-info" ng-click="grid.appScope.itemPOSelect(row.entity)"><i class="fa fa-archive"></i></button>


                                      </div>              `
                        },
                        {
                            field: 'KodeBarang',
                            name: 'Kode Barang',
                            width: "*"
                        },
                        {
                            field: 'NamaBarang',
                            name: 'Nama Barang',
                            width: "*"
                        },
                        {
                            field: 'Satuan',
                            name: 'Satuan',
                            width: "*"
                        },
                        {
                            field: 'HargaSatuan',
                            name: 'Harga',
                            width: "*"
                        },
                        {
                            field: 'Qty',
                            name: 'Qty Beli',
                            width: "*"
                        }, {
                            field: 'QtyTerima',
                            name: 'Qty Terima',
                            width: "*"
                        }
                    ]

                }
                break;
            case 'prViewList':

                $scope.optionsParams = {
                    url: 'api/purchase-requisition/' + $scope.params.params.no + '/detail?',
                    name: 'Daftar PR',
                    qry: {

                    },
                    column: [{
                            field: 'KodeBarang',
                            name: 'Kode Barang',
                            width: "*"
                        },
                        {
                            field: 'NamaBarang',
                            name: 'Nama Barang',
                            width: "*"
                        },
                        {
                            field: 'Satuan',
                            name: 'Satuan',
                            width: "*"
                        },
                        {
                            field: 'HargaSatuan',
                            name: 'Harga',
                            width: "*"
                        },
                        {
                            field: 'SubTotal',
                            name: 'Total',
                            width: "*"
                        }
                    ]

                }
                break;
            case 'preViewList':

                $scope.optionsParams = {
                    url: 'api/preceive/' + $scope.params.params.no + '/detail?',
                    name: 'Daftar Penerimaan ',
                    qry: {

                    },
                    column: [{
                            field: 'KodeBarang',
                            name: 'Kode Barang',
                            width: "*"
                        },
                        {
                            field: 'NamaBarang',
                            name: 'Nama Barang',
                            width: "*"
                        },
                        {
                            field: 'Satuan',
                            name: 'Satuan',
                            width: "*"
                        },
                        {
                            field: 'QtyTerima',
                            name: 'Qty',
                            width: "*"
                        },
                        {
                            field: 'HargaSatuan',
                            name: 'Harga',
                            width: "*"
                        },
                        {
                            field: 'SubTotal',
                            name: 'Total',
                            width: "*"
                        }
                    ]

                }
                break;
            case 'poViewList':

                $scope.optionsParams = {
                    url: 'api/po/' + $scope.params.params.no + '/detail?',
                    name: 'Daftar Detail PO',
                    qry: {

                    },
                    column: [{
                            field: 'KodeBarang',
                            name: 'Kode Barang',
                            width: "*"
                        },
                        {
                            field: 'NamaBarang',
                            name: 'Nama Barang',
                            width: "*"
                        },
                        {
                            field: 'Satuan',
                            name: 'Satuan',
                            width: "*"
                        },
                        {
                            field: 'HargaSatuan',
                            name: 'Harga',
                            width: "*"
                        },
                        {
                            field: 'SubTotal',
                            name: 'Total',
                            width: "*"
                        }
                    ]

                }
                break;
            case 'suratJalanDetailList':
                $scope.optionsParams = {
                    url: 'api/bagging-sj/' + $scope.params.params.id + '?',
                    name: 'Detail Rincian Surat Jalan',
                    qry: {},
                    column: [
                        { field: 'tujuan', name: 'Tujuan', width: "*" },
                        { field: 'total_koli', name: 'Total Koli', width: "15%" },
                        { field: 'total_weight', name: 'Total Berat', width: "20%" }
                    ]
                }
                break;
            case 'marketingCodeList':
                $scope.optionsParams = {
                    url: 'api/master-marketing-code?',
                    name: 'Daftar Marketing Code',
                    qry: {},
                    column: [
                        {
                            width: "80",
                            cellClass: "nggrid-action",
                            name: 'Pilih',
                            cellTemplate: '<div class="btn-group" style="padding:4px 0 0 8px;"><button type="button" class="btn btn-xs btn-info" ng-click="grid.appScope.pilihMarketingCode(row.entity)"><i class="fa fa-check"></i> Pilih</button></div>'
                        },
                        { field: 'marketing_code', name: 'Marketing Code', width: "150" },
                        { field: 'marketing_name', name: 'Nama Marketing', width: "*" }
                    ]
                };
                $scope.pilihMarketingCode = function (row) {
                    $rootScope.$broadcast('pilih-marketing-code', row);
                    $uibModalInstance.close(row);
                };
                break;
            case 'poReceiveList':
                $scope.optionsParams = {
                    url: 'api/preceive/po?',
                    name: 'Daftar PO',
                    qry: {

                    },
                    column: [{
                            width: "10%",
                            cellClass: "nggrid-action",
                            name: 'Actions',
                            cellTemplate: `<div class="btn-group">
                                <button type="button" class="btn btn-sm btn-icon btn-info" ng-click="grid.appScope.poReceiveSelect(row.entity)"><i class="fa fa-archive"></i></button>
                              </div>`
                        },
                        {
                            field: 'NOPO',
                            name: 'PR',
                            width: "*"
                        },
                        {
                            field: 'NoBukti',
                            name: 'Nomor PO',
                            width: "*"
                        },
                        {
                            field: 'Tanggal',
                            name: 'Tanggal',
                            width: "*"
                        },
                        {
                            field: 'Keterangan',
                            name: 'Keterangan',
                            width: "*"
                        },
                        {
                            field: 'Vendor_Name',
                            name: 'Nama Vendor',
                            width: "*"
                        },
                       
                        {
                            field: 'SisaQty',
                            name: 'Telah di terima',
                            width: "*"
                        }
                    ]

                }
                break;
            case 'vendorList':
                $scope.optionsParams = {
                    url: 'api/contact/vendor?filter=GENERAL AFFAIR',
                    name: 'Daftar Vendor',
                    qry: {

                    },
                    column: [{
                            width: "10%",
                            cellClass: "nggrid-action",
                            name: 'Actions',
                            cellTemplate: ` <div class="btn-group">
                                    <button type="button" class="btn btn-sm btn-icon btn-info" ng-click="grid.appScope.vendorSelect(row.entity)"><i class="fa fa-archive"></i></button>


                                  </div>              `
                        },
                        {
                            field: 'KodeCustomer',
                            name: 'Kode',
                            width: "*"
                        },
                        {
                            field: 'NamaCustomer',
                            name: 'Nama',
                            width: "*"
                        },
                        {
                            field: 'Alamat',
                            name: 'Alamat',
                            width: "*"
                        }
                    ]


                }
                break;
            case 'pr-poList':
                $scope.optionsParams = {
                    url: 'api/po-pr?',
                    name: 'Daftar List PR',
                    qry: {

                    },
                    column: [{
                            width: "10%",
                            cellClass: "nggrid-action",
                            name: 'Actions',
                            cellTemplate: ` <div class="btn-group">
                                        <button type="button" class="btn btn-sm btn-icon btn-info" ng-click="grid.appScope.prpoSelect(row.entity)"><i class="fa fa-archive"></i></button>


                                      </div>              `
                        },
                        {
                            field: 'NoBukti',
                            name: 'Nomor PR',
                            width: "*"
                        },
                        {
                            field: 'Tanggal',
                            name: 'Tanggal',
                            width: "*"
                        },
                        {
                            field: 'Keterangan',
                            name: 'Keterangan',
                            width: "*"
                        },

                        {
                            field: 'TotalQty',
                            name: 'Total Request',
                            width: "*"
                        },
                        {
                            field: 'SisaQty',
                            name: 'PO',
                            width: "*"
                        }
                    ]

                }
                break;
            case 'agenList':
                $scope.optionsParams = {
                    url: 'api/masteragen?',
                    name: 'Daftar Departmen',
                    qry: {

                    },
                    column: [{
                            width: "10%",
                            cellClass: "nggrid-action",
                            name: 'Actions',
                            cellTemplate: ` <div class="btn-group">
                                        <button type="button" class="btn btn-sm btn-icon btn-info" ng-click="grid.appScope.agenSelect(row.entity)"><i class="fa fa-archive"></i></button>


                                      </div>              `
                        },
                        {
                            field: 'KodeUser',
                            name: 'Departement',
                            width: "*"
                        }
                    ]
                }
                break;
            case 'hostList':
                if ($scope.params && $scope.params.params.isFrom) {
                    $scope.isFrom = $scope.params.params.isFrom;
                }
                $scope.optionsParams = {
                    url: 'api/host?',
                    name: 'Host List',
                    qry: {},
                    column: [{
                            width: "10%",
                            cellClass: "nggrid-action",
                            name: 'Actions',
                            cellTemplate: ` <div class="btn-group">
                            <button type="button" class="btn btn-sm btn-icon btn-info" ng-click="grid.appScope.hostSelect(row.entity)"><i class="fa fa-archive"></i></button>
                            </div>`
                        },
                        {
                            field: 'HostCode',
                            name: 'Host Code',
                            width: "*",
                            resizable: false
                        },
                        {
                            field: 'HostName',
                            name: 'Name',
                            width: "*"
                        }
                    ]

                }
                break;
            case 'cityList':
                console.log('-----city list')
                if ($scope.params && $scope.params.params.isFrom) {
                    $scope.isFrom = $scope.params.params.isFrom;
                }
                $scope.optionsParams = {
                    url: 'api/destination?',
                    name: 'City List',
                    qry: {},
                    column: [{
                            width: "10%",

                            name: 'Actions',
                            cellTemplate: ` <div class="btn-group">
                            <button type="button" class="btn btn-sm btn-icon btn-info" ng-click="grid.appScope.citySelect(row.entity)"><i class="fa fa-archive"></i></button>
                            </div>`
                        },
                        {
                            field: 'CityCode',
                            name: 'Destination ID',
                            width: "*",
                            resizable: false
                        },
                        {
                            field: 'CityName',
                            name: 'Destination',
                            width: "*"
                        },
                        {
                            field: 'HostCode',
                            name: 'Host ID',
                            width: "*",
                            resizable: false
                        },
                        {
                            field: 'HostName',
                            name: 'Host Name',
                            width: "*"
                        }


                    ]

                }
                break;
            case 'baggingHubList':
                $scope.lookupType = $scope.params && $scope.params.params ? ($scope.params.params.lookupType || 'origin') : 'origin';
                $scope.optionsParams = {
                    url: 'api/bagging-master/hubs?',
                    name: 'Lookup Hub Bagging',
                    qry: {},
                    column: [{
                            width: '10%',
                            cellClass: 'nggrid-action',
                            name: 'Actions',
                            cellTemplate: ` <div class="btn-group">
                            <button type="button" class="btn btn-sm btn-icon btn-info" ng-click="grid.appScope.baggingHubSelect(row.entity)"><i class="fa fa-archive"></i></button>
                            </div>`
                        },
                        {
                            field: 'hub_id',
                            name: 'Kode Hub',
                            width: '*',
                            resizable: false
                        },
                        {
                            field: 'hub_name',
                            name: 'Nama Hub',
                            width: '*'
                        },
                        {
                            field: 'province_id',
                            name: 'Province',
                            width: '*'
                        }
                    ]
                }
                break;
            case 'baggingAgentList':
                $scope.optionsParams = {
                    url: 'api/bagging-entry/agents?',
                    name: 'Lookup Agen Bagging',
                    qry: {},
                    column: [{
                            width: '10%',
                            cellClass: 'nggrid-action',
                            name: 'Actions',
                            cellTemplate: ` <div class="btn-group">
                            <button type="button" class="btn btn-sm btn-icon btn-info" ng-click="grid.appScope.baggingAgentSelect(row.entity)"><i class="fa fa-archive"></i></button>
                            </div>`
                        },
                        {
                            field: 'contact_reff',
                            name: 'Kode',
                            width: '*',
                            resizable: false
                        },
                        {
                            field: 'name',
                            name: 'Nama',
                            width: '*'
                        },
                        {
                            field: 'contact_type',
                            name: 'Tipe',
                            width: '*'
                        }
                    ]
                }
                break;
            case 'baggingEntryList':
                $scope.optionsParams = {
                    url: 'api/bagging-entry/lookup?',
                    name: 'Cari Bagging',
                    qry: {},
                    column: [{
                            width: '10%',
                            cellClass: 'nggrid-action',
                            name: 'Actions',
                            cellTemplate: ` <div class="btn-group">
                            <button type="button" class="btn btn-sm btn-icon btn-info" ng-click="grid.appScope.baggingEntrySelect(row.entity)"><i class="fa fa-archive"></i></button>
                            </div>`
                        },
                        {
                            field: 'bag_id',
                            name: 'Nomor Bagging',
                            width: 180,
                            minWidth: 160,
                            resizable: false
                        },
                        {
                            field: 'manifest_date',
                            name: 'Tanggal',
                            width: 120,
                            minWidth: 100,
                            cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.manifest_date | date:"dd-MM-yyyy"}}</div>'
                        },
                        {
                            field: 'host_name',
                            name: 'Asal',
                            width: 200,
                            minWidth: 160
                        },
                        {
                            field: 'destination_host_name',
                            name: 'Tujuan',
                            width: 200,
                            minWidth: 160
                        },
                        {
                            field: 'status',
                            name: 'Status',
                            width: 110,
                            minWidth: 100
                        },
                        {
                            field: 'total_awb',
                            name: 'Total AWB',
                            width: 100,
                            minWidth: 90
                        }
                    ]
                }
                break;
            case 'baggingDestinationList':
                $scope.lookupHubId = $scope.params && $scope.params.params ? ($scope.params.params.hubId || '') : '';
                $scope.optionsParams = {
                    url: 'api/bagging-master/destinations?hubId=' + encodeURIComponent($scope.lookupHubId || '') + '&',
                    name: 'Lookup Kota Bagging',
                    qry: {},
                    column: [{
                            width: '10%',
                            cellClass: 'nggrid-action',
                            name: 'Actions',
                            cellTemplate: ` <div class="btn-group">
                            <button type="button" class="btn btn-sm btn-icon btn-info" ng-click="grid.appScope.baggingDestinationSelect(row.entity)"><i class="fa fa-archive"></i></button>
                            </div>`
                        },
                        {
                            field: 'dest_id',
                            name: 'Kode Kota',
                            width: '*',
                            resizable: false
                        },
                        {
                            field: 'dest_name',
                            name: 'Destination',
                            width: '*'
                        },
                        {
                            field: 'city',
                            name: 'Kota',
                            width: '*'
                        },
                        {
                            field: 'hub_id',
                            name: 'Tujuan Hub',
                            width: '*'
                        },
                        {
                            field: 'hub_name',
                            name: 'Nama Hub',
                            width: '*'
                        }
                    ]
                }
                break;
            case 'courierList':
                $scope.optionsParams = {
                    url: 'api/mastercourier?',
                    name: 'Courier List',
                    qry: {

                    },
                    column: [{
                            width: "10%",
                            cellClass: "nggrid-action",
                            name: 'Actions',
                            cellTemplate: ` <div class="btn-group">
                                                <button type="button" class="btn btn-sm btn-icon btn-info" ng-click="grid.appScope.courierSelect(row.entity)"><i class="fa fa-archive"></i></button>


                                              </div>              `
                        },
                        {
                            field: 'CourierCode',
                            name: 'Courier ID',
                            width: "*",
                            resizable: false
                        },
                        {
                            field: 'CourierName',
                            name: 'name',
                            width: "*"
                        }
                    ]

                }
                break;
            case 'customerList':
                var customerListUrl = ($scope.params && $scope.params.params && $scope.params.params.customerListUrl) || null;

                if ($scope.params && $scope.params.params.isReceiver) {
                    $scope.isFrom = $scope.params.params.isReceiver;
                }
                $scope.optionsParams = {
                    url: customerListUrl || ('api/contact?' + (($scope.params && $scope.params.params && $scope.params.params.isConnoteMode) ? 'is_connote=1&' : '')),
                    name: 'Customer List',
                    qry: {

                    },
                    column: [{
                            width: 70,
                            minWidth: 70,
                            cellClass: "nggrid-action",
                            name: 'Actions',
                            cellTemplate: ` <div class="btn-group">
                                                            <button type="button" class="btn btn-sm btn-icon btn-info" ng-click="grid.appScope.customerSelect(row.entity)"><i class="fa fa-archive"></i></button>


                                                          </div>              `
                        },
                        {
                            field: 'CustomerCode',
                            name: 'Customer Code',
                            width: 130,
                            minWidth: 120,
                            resizable: false
                        },
                        {
                            field: 'CustomerName',
                            name: 'Name',
                            width: 420,
                            minWidth: 360,
                            resizable: true,
                            cellTemplate: '<div class="ui-grid-cell-contents" title="{{row.entity.CustomerName || \"\"}}">{{row.entity.CustomerName || "-"}}</div>'
                        },
                        {
                            field: 'Address',
                            name: 'Address',
                            width: 260,
                            minWidth: 220,
                            cellTemplate: '<div class="ui-grid-cell-contents" title="{{row.entity.Address || \"\"}}">{{row.entity.Address || "-"}}</div>'
                        },
                        {
                            field: 'BranchID',
                            name: 'Branch',
                            width: 90,
                            minWidth: 80
                        },
                        {
                            field: 'MarketingCode',
                            name: 'Marketing',
                            width: 220,
                            minWidth: 180,
                            cellTemplate: '<div class="ui-grid-cell-contents" title="{{row.entity.MarketingCode || \"\"}}">{{row.entity.MarketingCode || "-"}}</div>'
                        }
                    ]

                }
                applyCustomerListColumnSizing([]);
                break;
            case 'marketingCodeList':
                $scope.optionsParams = {
                    url: 'api/e-waybill-numbering-masters/marketing-code-options?',
                    name: 'Marketing Code List',
                    qry: {

                    },
                    column: [{
                            width: 70,
                            minWidth: 70,
                            cellClass: 'nggrid-action',
                            name: 'Actions',
                            cellTemplate: ` <div class="btn-group">
                                                            <button type="button" class="btn btn-sm btn-icon btn-info" ng-click="grid.appScope.marketingCodeSelect(row.entity)"><i class="fa fa-archive"></i></button>


                                                          </div>              `
                        },
                        {
                            field: 'MarketingCode',
                            name: 'Marketing Code',
                            width: 320,
                            minWidth: 260,
                            cellTemplate: '<div class="ui-grid-cell-contents" title="{{row.entity.MarketingCode || ""}}">{{row.entity.MarketingCode || "-"}}</div>'
                        },
                        {
                            field: 'TotalCustomer',
                            name: 'Total Customer',
                            width: 140,
                            minWidth: 120
                        },
                        {
                            field: 'DefaultPrefix',
                            name: 'Prefix',
                            width: 100,
                            minWidth: 90,
                            cellTemplate: '<div class="ui-grid-cell-contents" title="{{row.entity.DefaultPrefix || ""}}">{{row.entity.DefaultPrefix || "-"}}</div>'
                        }
                    ]

                }
                break;
            case 'baggingDetailList':
                console.log($scope.params)
                if ($scope.params && $scope.params.params.no) {
                    $scope.no = $scope.params.params.no;
                }
                $scope.optionsParams = {
                    url: 'api/bagging/'+$scope.no+'/detail?',
                    name: 'Detail Bag : ' + $scope.no,
                    qry: {

                    },
                    column: [{
                            field: 'AWB',
                            name: 'AWB',
                            width: "*",
                            resizable: false
                        },
                        {
                            field: 'AWB_Date',
                            name: 'Date',
                            width: "*"
                        },  {
                            field: 'Org_Code',
                            name: 'Origin',
                            width: "*"
                        },
                        {
                            field: 'Dest_Host_Code',
                            name: 'Host',
                            width: "*"
                        },
                        {
                            field: 'Dest_Code',
                            name: 'Destination Code',
                            width: "*"
                        },
                        {
                            field: 'Dest_Name',
                            name: 'Destination',
                            width: "*"
                        },
                        {
                            field: 'Shipper_Name',
                            name: 'Shipper',
                            width: "*"
                        },

                        {
                            field: 'Weight',
                            name: 'We',
                            width: "*"
                        },
                        {
                            field: 'Collie',
                            name: 'Koli',
                            width: "*"
                        },

                        {
                            field: 'collie_bagging',
                            name: 'Koli Baging',
                            width: "*"
                        },

                    ]

                }
                break;
            case 'unmanifestHostList':
                if ($scope.params && $scope.params.params.host) {
                    $scope.host = $scope.params.params.host;
                }
                $scope.optionsParams = {
                    url: 'api/bagging/' + $scope.host + '/unmanifest?',
                    name: 'Unmanifest AWB : ' + $scope.host,
                    qry: {

                    },
                    column: [{
                            width: "10%",
                            cellClass: "nggrid-action",
                            name: 'Actions',
                            cellTemplate: ` <div class="btn-group">
                                                                        <button type="button" class="btn btn-sm btn-icon btn-info" ng-click="grid.appScope.awbSelect(row.entity)"><i class="fa fa-archive"></i></button>


                                                                      </div>              `
                        },
                        {
                            field: 'AWB',
                            name: 'AWB',
                            width: "*",
                            resizable: false
                        },
                        {
                            field: 'Org_Name',
                            name: 'Origin',
                            width: "*"
                        },
                        {
                            field: 'Dest_Host_Code',
                            name: 'Host',
                            width: "*"
                        },
                        {
                            field: 'Dest_Code',
                            name: 'Destination Code',
                            width: "*"
                        },
                        {
                            field: 'Dest_Name',
                            name: 'Destination',
                            width: "*"
                        },
                        {
                            field: 'Shipper_Name',
                            name: 'Shipper',
                            width: "*"
                        },
                        {
                            field: 'Consign_Name',
                            name: 'Receiver',
                            width: "*"
                        },
                        {
                            field: 'sisa_collie',
                            name: 'collie Baging',
                            width: "*"
                        },
                        {
                            field: 'Weight',
                            name: 'We',
                            width: "*"
                        },
                        {
                            field: 'UOM',
                            name: 'UOM',
                            width: "*"
                        }
                    ]

                }
                break;
            case 'coaList':
                if ($scope.params && $scope.params.params.isFrom) {
                    $scope.isFrom = $scope.params.params.isFrom;
                }
                $scope.optionsParams = {
                    url: 'api/coa/list?',
                    name: 'Daftar Kode Perkiraan',
                    qry: {

                    },
                    column: [{
                            width: "10%",
                            cellClass: "nggrid-action",
                            name: 'Actions',
                            cellTemplate: ` <div class="btn-group">
                                            <button type="button" class="btn btn-sm btn-icon btn-info" ng-click="grid.appScope.coaSelect(row.entity)"><i class="fa fa-archive"></i></button>


                                          </div>              `
                        },
                        {
                            field: 'KodePerkiraan',
                            name: 'Account Code',
                            width: "*"
                        },
                        {
                            field: 'NamaPerkiraan',
                            name: 'Account Name',
                            width: "*"
                        }
                    ]
                }
                break;
            default:
                $scope.close();
                break;
        }
        /** Listening */

        $scope.vendorSelect = function (c) {
            //console.log($scope.isFrom);
            $rootScope.$broadcast('pilih-vendor', {
                vendor: c
            });
            $uibModalInstance.close();
        };

        $scope.itemSelect = function (c) {
            //console.log($scope.isFrom);
            $rootScope.$broadcast('pilih-item', {
                item: c
            });
            $uibModalInstance.close();
        };
        $scope.itemPOSelect = function (c) {
            //console.log($scope.isFrom);
            $rootScope.$broadcast('pilih-item-po', {
                item: c
            });
            $uibModalInstance.close();
        };


        $scope.poReceiveSelect = function (c) {
            //console.log($scope.isFrom);
            $rootScope.$broadcast('pilih-po', {
                po: c
            });
            $uibModalInstance.close();
        };

        $scope.prpoSelect = function (c) {
            console.log(c);
            $rootScope.$broadcast('pilih-pr', {
                pr: c
            });
            $uibModalInstance.close();
        }

        $scope.agenSelect = function (c) {
            $rootScope.$broadcast('pilih-agent', {
                agen: c
            });
            $uibModalInstance.close();
        }
        $scope.citySelect = function (c) {
            //console.log($scope.isFrom);
            $rootScope.$broadcast('pilih-kota', {
                isFrom: $scope.isFrom,
                city: c
            });
            $uibModalInstance.close();
        };

        $scope.courierSelect = function (c) {

            $rootScope.$broadcast('pilih-courier', c);
            $uibModalInstance.close();
        };
        $scope.customerSelect = function (c) {
            if ($scope.isFrom) {
                c.isReceiver = true;
            }
            $rootScope.$broadcast('pilih-contact', c);
            $uibModalInstance.close();
        };
        $scope.marketingCodeSelect = function (item) {
            $rootScope.$broadcast('pilih-marketing-code', item);
            $uibModalInstance.close();
        };
        $scope.hostSelect = function (c) {
            //console.log($scope.isFrom);
            $rootScope.$broadcast('pilih-host', {
                isFrom: $scope.isFrom,
                host: c
            });
            $uibModalInstance.close();
        };

        $scope.baggingHubSelect = function (c) {
            $rootScope.$broadcast('pilih-bagging-hub', {
                lookupType: $scope.lookupType,
                hub: c
            });
            $uibModalInstance.close();
        };

        $scope.baggingDestinationSelect = function (c) {
            $rootScope.$broadcast('pilih-bagging-destination', {
                destination: c
            });
            $uibModalInstance.close();
        };

        $scope.baggingAgentSelect = function (c) {
            $rootScope.$broadcast('pilih-bagging-agent', {
                agent: c
            });
            $uibModalInstance.close();
        };

        $scope.baggingEntrySelect = function (c) {
            $rootScope.$broadcast('pilih-bagging-entry', {
                bagging: c
            });
            $uibModalInstance.close();
        };

        $scope.awbSelect = function (c) {
            $rootScope.$broadcast('pilih-awb', {

                awb: c
            });
            $uibModalInstance.close();
        }
        $scope.coaSelect = function (c) {
            $rootScope.$broadcast('pilih-coa', {
                isFrom: $scope.isFrom,
                coa: c
            });
            $uibModalInstance.close();
        };
        /** end of listening */

        $scope.filterOptions = {
            filterText: "",
            useExternalFilter: true
        };
        $scope.filterSearchRealtime = function () {
            if (filterSearchTimer) {
                $timeout.cancel(filterSearchTimer);
            }

            filterSearchTimer = $timeout(function () {
                paginationOptions.pageNumber = 1;
                $scope.getPagedDataAsync(paginationOptions.pageSize, paginationOptions.pageNumber, $scope.filterOptions.filterText || '');
            }, getPopupSearchDelay());
        };
        $scope.filterSearch = function () {
            if (filterSearchTimer) {
                $timeout.cancel(filterSearchTimer);
            }
            paginationOptions.pageNumber = 1;
            $scope.getPagedDataAsync(paginationOptions.pageSize, paginationOptions.pageNumber, $scope.filterOptions.filterText || '');
        }
        $scope.getPagedDataAsync = function (pageSize, page, searchText) {
            var qry;
            var ft;

            console.log('Search text', searchText);
            if (searchText) {
                ft = searchText.toLowerCase();
                qry = 'qry=' + JSON.stringify($scope.optionsParams.qry) + '&pg=' + page + '&limit=' + pageSize + '&term=' + ft;
            } else {
                qry = 'qry=' + JSON.stringify($scope.optionsParams.qry) + '&pg=' + page + '&limit=' + pageSize;
            }
            console.log($scope.optionsParams.url + qry);
            urlServices.ambilData($scope.optionsParams.url + qry, {}, function (e, d) {
                console.log('-------', d);
                if (e) {
                    if (e && e.err && e.err instanceof Array) {
                        $scope.errorMessage = e.err;
                        var elP = '';
                        for (var key in $scope.errorMessage) {
                            elP += '<p>' + $scope.errorMessage[key].msg + '</p>';
                        }

                        toaster.pop('error', 'Error Data', elP);

                    } else {

                        toaster.pop('error', 'Error Data', e.err);

                    }
                    $scope.gridOptions.totalItems = 0;
                    $scope.gridOptions.data = []

                } else {
                    //console.log(d);
                    if (d && d.count) {

                        $scope.gridOptions.totalItems = d.count;
                        $scope.gridOptions.data = d.rows;
                        applyCustomerListColumnSizing(d.rows);

                    } else {
                        console.log('herere', d);
                        if (d && d.records !== undefined && d.data !== undefined) {
                            $scope.gridOptions.totalItems = d.records;
                            $scope.gridOptions.data = d.data;
                            applyCustomerListColumnSizing(d.data);
                        } else if (d && !d.total) {
                            $scope.gridOptions.totalItems = d.length;
                            $scope.gridOptions.data = d;
                            applyCustomerListColumnSizing(d);
                        } else {

                            $scope.gridOptions.totalItems = d.total;
                            $scope.gridOptions.data = d.dt;
                            applyCustomerListColumnSizing(d.dt);
                        }


                    }

                }
            })
        };

        var paginationOptions = {
            pageNumber: 1,
            pageSize: _VAR_GLOBAL.limit,
            sort: null
        };


        $scope.gridOptions = {
            paginationPageSizes: [10, 20, 50, 100],
            paginationPageSize: _VAR_GLOBAL.limit,
            enableColumnResizing: true,
            useExternalPagination: true,
            useExternalSorting: true,
            columnDefs: $scope.optionsParams.column,
            onRegisterApi: function (gridApi) {

                $scope.gridApi = gridApi;
                $scope.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
                    if (sortColumns.length == 0) {
                        paginationOptions.sort = null;
                    } else {
                        paginationOptions.sort = sortColumns[0].sort.direction;
                    }
                    $scope.getPagedDataAsync(paginationOptions.pageSize, paginationOptions.pageNumber, $scope.filterOptions.filterText || '');
                });
                gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                    paginationOptions.pageNumber = newPage;
                    paginationOptions.pageSize = pageSize;
                    $scope.getPagedDataAsync(paginationOptions.pageSize, paginationOptions.pageNumber, $scope.filterOptions.filterText || '');
                });
            }
        };
        $scope.getPagedDataAsync(paginationOptions.pageSize, paginationOptions.pageNumber, $scope.filterOptions.filterText || '');
        $scope.close = function () {
            console.log('batal====')
            $uibModalInstance.close();
        };
    })
    .controller('modalTracingCtrl', function ($rootScope, $scope, urlServices, $uibModalInstance, $filter, toaster, _VAR_GLOBAL, params) {
        console.log('paramtere', params)
        $scope.optionsParams = {
            name: 'Tracing'
        };
        $scope.params = params.params;
        console.log($scope.params);
        urlServices.ambilData('api/outbound/tracing/' + $scope.params.params, {

        }, function (e, d) {
            console.log(d);
            $scope.dtTrace = d;

        });
        $scope.close = function () {
            $uibModalInstance.close();
        };
    });